import React from "react";
import queryString from "query-string";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ErrorMessage } from "components/shared/ErrorMessage/ErrorMessage";
import { useErrorHandler } from "lib/hooks/useErrorHandler";
import { TextField } from "components/shared/TextField/TextField";
import Button from "components/shared/Button/Button";
import { useResetPasswordMutation } from "graphql/generated/generated";
import { useSnackbar } from "lib/context/SnackbarContext/SnackbarContext";
import { useRouter } from "lib/hooks/useRouter";
import { useResetPasswordFormik } from "lib/hooks/formik/useResetPasswordFormik";

const useStyles = makeStyles({
  resetPasswordForm: {
    width: "100%",
    maxWidth: 500,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
  },

  paper: {
    padding: "30px",
  },

  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  resetPasswordActions: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginTop: 15,
    "& a": {
      textDecoration: "none",
      borderBottom: "1px solid #333",
    },
  },
  resetPasswordWithEmail: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

export const ResetPasswordForm = () => {
  const classes = useStyles();
  const errorHandler = useErrorHandler();
  const snackbar = useSnackbar();
  const router = useRouter<any>();
  const [resetPassword] = useResetPasswordMutation();

  const params = queryString.parse(router.location.search);

  const formik = useResetPasswordFormik({
    initialValues: {
      key: (params.key || "") as string,
      login: (params?.login || "") as string,
      password: "",
      passwordConfirm: "",
    },
    onSubmit: async (values, formikHelpers) => {
      try {
        errorHandler.reset();
        formikHelpers.setErrors({});
        await resetPassword({
          variables: {
            key: values.key,
            login: values.login,
            password: values.password,
          },
        });
        formikHelpers.resetForm();
        snackbar.info("Fjalëkalimi është rivendosur me sukses");
        router.history.push("/login");
      } catch (e) {
        errorHandler.handleError(e);
        formikHelpers.setErrors({ password: "", passwordConfirm: "" });
      }
    },
  });

  const { errors, touched } = formik;

  return (
    <div className={classes.resetPasswordForm}>
      <Paper className={classes.paper}>
        <form onSubmit={formik.handleSubmit} className={classes.form}>
          <ErrorMessage
            showCloseButton
            error={errorHandler.error}
            alertProps={{ style: { marginBottom: 15, width: "100%" } }}
            onClose={() => {
              errorHandler.reset();
              formik.setErrors({});
            }}
          />

          <TextField
            fullWidth
            type="password"
            name="password"
            id="password"
            label="Fjalëkalimi"
            error={touched.password && !!errors.password}
            helperText={touched.password ? errors.password : undefined}
            value={formik.values.password || ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />

          <TextField
            fullWidth
            type="password"
            name="passwordConfirm"
            id="passwordConfirm"
            label="Konfirmo fjalëkalimin"
            error={touched.passwordConfirm && !!errors.passwordConfirm}
            helperText={
              touched.passwordConfirm ? errors.passwordConfirm : undefined
            }
            value={formik.values.passwordConfirm || ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />

          <div className={classes.resetPasswordActions}>
            <div className={classes.resetPasswordWithEmail}>
              <Button
                type="submit"
                disabled={formik.isSubmitting}
                color="primary"
              >
                {formik.isSubmitting ? "Ju lutem prisni" : "Ruaj"}
              </Button>
            </div>
          </div>
        </form>
      </Paper>
    </div>
  );
};
